import { render, staticRenderFns } from "./CreateVesselGroupDialog.vue?vue&type=template&id=1d317249&scoped=true&"
import script from "./CreateVesselGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateVesselGroupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateVesselGroupDialog.vue?vue&type=style&index=0&id=1d317249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d317249",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSpacer,VTextField})
